// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2dRuY","info":"Note_info__2h0mi","note":"Note_note__f7fBG","actions":"Note_actions__34rv0"};